import { useEffect } from 'react';
import { useMantineTheme } from '@mantine/core';
import { useMediaQuery } from '@mantine/hooks';

/**
 * Закрывает мобильное меню при переходе на ширину md и выше. Меню там скрыто стилями, но открытое оно держало бы
 * блокировку прокрутки страницы (расширение окна, поворот планшета).
 */
export function useCloseOnDesktop(close: () => void): void {
  const theme = useMantineTheme();
  const desktop = useMediaQuery(`(min-width: ${theme.breakpoints.md})`);

  useEffect(() => {
    if (desktop) {
      close();
    }
  }, [desktop, close]);
}
